export default "__VITE_ASSET__a1954110__"